/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}accordion`;
const attributes = {
    PANEL_SELECTOR: 'panel-selector'
};
const events = {
    TOGGLE: `${elementName}-toggle`
};
export const ACCORDION_CONSTANTS = {
    elementName,
    attributes,
    events
};
